import { api, tokens } from "./api";

export async function login(username, password) {
  const data = await api.post("/api/login", { username, password });
  tokens.set({ access: data.access, refresh: data.refresh });
  // Everything /api/me returns, minus the tokens — which are held by
  // `tokens`, not by the identity in the store. Picking fields by hand here
  // silently dropped `permissions`, so the sider rendered ungated until a
  // reload ran restoreSession() and fetched the identity properly.
  const { access: _a, refresh: _r, ...identity } = data;
  return identity;
}

export async function logout() {
  try {
    await api.post("/api/logout");
  } finally {
    // Tokens are stateless, so signing out is the client discarding them —
    // do it even if the courtesy call to the server fails.
    tokens.clear();
  }
}

export const me = () => api.get("/api/me");
